import script from "./KCheckoutButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCheckoutButton.vue?vue&type=script&setup=true&lang=ts"

import "./KCheckoutButton.vue?vue&type=style&index=0&id=684f8523&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-684f8523"]])

export default __exports__